import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";

export const addJob = (data: any) => {
    return postApi(constants.urls.JOB_ADD, data);
};

export const editJob = (data: any, id: string) => {
    return putApi(constants.urls.JOB_EDIT + "/" + id, data);

};

export const jobStatus = (id:any, flag:any) => {
  return putApi(constants.urls.JOB_STATUS + "/" + id+"/"+flag, {});

};

export const getPatientlistcount = () => {
  return getApi(constants.urls.PATIENT_COUNT);
};

export const listJob= (params: string = "") => {
    return getApi(constants.urls.JOB_LIST, params);

};
export const deleteJob = (id: string) => {
    return deleteApi(constants.urls.JOB_DELETE + "/" + id+"?hard=true");
};


export const getByJobId = (id: string) => {
    return getApi(constants.urls.JOB_GETBYID + "/" + id);
};

export const rollbackJob = (id: string) => {
  return deleteApi(constants.urls.JOB_DROPDOWN + "/" + id);
};

export const jobDropdown = () => {
  return getApi(constants.urls.JOB_DROPDOWN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

export const employeeDropdownHandyman = () => {
  return getApi(constants.urls.JOB_DROPDOWN_HANDYMAN).then((res: any) => res.map((item: any) => {
    return {
      id: item.id,
      label: item.f_name + " "+ item.l_name
    }
  }))
};

 export const getstatus = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:0,
            label:"Inactive"
          },
          {
            id:1,
            label:"Active"
          }
        ])
      })
    })
  }

  export const getRole = () =>{
    return new Promise((resolve,reject)=>{
      setTimeout(()=>{
        resolve([
          {
            id:1,
            label:"Admin"
          },
          {
            id:2,
            label:"User"
          },
        ])
      })
    })
  }